import type { Orientation } from '@ui/types/base/orientation'

const orientationMap: Record<Orientation, string> = {
  horizontal: 'flex flex-row horizontal space-x-2',
  vertical: 'flex flex-col vertical space-y-2'
}

export const useOrientation = (orientation: Orientation) => orientationMap[orientation]
